<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="creategroup"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("new_group") }}
            </h5>
            <div
              v-if="mssg"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="addgroup">
              <div class="form-group">
                <label>{{ $t("group_name") }}</label>
                <input
                  type="text"
                  name="group_name"
                  v-model="group_name"
                  class="form-control"
                  required
                />
              </div>

              <div class="form-group">
                <label for="">Group Storage</label>
                <div v-click-outside="closeDropdown">
                  <div
                    class="form-control cursor-pointer d-flex justify-content-between align-items-center"
                    @click="showDropdown = !showDropdown"
                  >
                    {{ storage ? dropDownName : "-- Select Storage --" }}

                    <i
                      class="fa fa-caret-down"
                      :class="{
                        'fa-caret-up': showDropdown,
                        'fa-caret-down': !showDropdown,
                      }"
                    ></i>
                  </div>
                  <div class="storage-dropdown" v-if="showDropdown">
                    <ul class="position-absolute w-100">
                      <li
                        v-for="({ img, value, name }, i) in storageTypes"
                        :key="i"
                        class="p-2 d-flex col-gap-1 align-items-center cursor-pointer font-weight-bold text-white font-16"
                        :class="{ active: value === storage }"
                        @click="
                          storage = value;
                          dropDownName = name;
                          showDropdown = false;
                        "
                      >
                        <span>
                          <div>
                            <div v-if="value == 'others'">
                              &#xb0;&#xb0;&#xb0;
                            </div>
                            <img v-else :src="img" alt="" />
                          </div>
                        </span>
                        {{ name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("If Others, please specify") }}</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="others"
                        :disabled="storage !== 'others'"
                        :required="storage === 'others'"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("Capacity") }}</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="capacity"
                        required
                      />
                    </div>
                    <p
                      v-if="capacity && !alphanumeric(capacity)"
                      class="font-12 error"
                    >
                      {{ $t("valid-measurement") }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("min-temp") }}</label>
                    <div class="input-group">
                      <input
                        type="number"
                        step="any"
                        name="min_temp"
                        class="form-control"
                        v-model="minTemp"
                        required
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">°C</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("max-temp") }}</label>
                    <div class="input-group">
                      <input
                        type="number"
                        step="any"
                        name="max_temp"
                        class="form-control"
                        v-model="maxTemp"
                        required
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">°C</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("min-humid") }}</label>
                    <div class="input-group">
                      <input
                        type="number"
                        step="any"
                        name="minHumi"
                        class="form-control"
                        v-model="minHumi"
                        required
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("max-humid") }}</label>
                    <div class="input-group">
                      <input
                        type="number"
                        step="any"
                        name="maxHumi"
                        class="form-control"
                        v-model="maxHumi"
                        required
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="form-group mb-0"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="!alphanumeric(capacity)"
                >
                  {{ $t("create_grp") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import warehouse from "../../assets/images/house.svg";
import truck from "../../assets/images/truck.svg";
import reefers from "../../assets/images/reefer.svg";

export default {
  name: "AddGroup",
  props: {
    show: Boolean,
    step1Payload: Object,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      group_name: "",
      group_description: "",
      minTemp: "",
      maxTemp: "",
      minHumi: "",
      maxHumi: "",
      mssg: "",
      Errormssg: "",
      capacity: "",
      others: "",
      storage: "",
      storageTypes: [
        {
          name: "Ware House",
          value: "warehouse",
          img: warehouse,
        },
        {
          name: "Truck",
          value: "truck",
          img: truck,
        },
        {
          name: "Reefers",
          value: "reefers",
          img: reefers,
        },
        {
          name: "Others",
          value: "others",
        },
      ],
      showDropdown: false,
      dropDownName: "",
    };
  },
  components: {
    Loading,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["addGroup", "fetchGroups"]),
    onCancel() {
      this.$emit("closeGroupModal");
    },
    addgroup() {
      // this.isLoading = true;
      const storage = () => {
        let storage;
        if (this.storage === "others") {
          storage = this.others;
        } else storage = this.storage;

        return storage;
      };
      const newgroup = {
        name: this.group_name,
        minTemp: this.minTemp,
        maxTemp: this.maxTemp,
        minHumidity: this.minHumi,
        maxHumidity: this.maxHumi,
        storage: storage(),
        capacity: this.capacity,
      };
      this.$emit("payload", newgroup);
    },
    // maxWords(evt) {
    //   if (evt.target.value.length > 149) {
    //     evt.preventDefault();
    //     return;
    //   }
    // },
    closeDropdown() {
      this.showDropdown = false;
    },
    alphanumeric(inputtxt) {
      let letterNumber = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
      return !!inputtxt.match(letterNumber);
    },
  },
  watch: {
    storage: {
      handler: function() {
        if (this.storage === "others") return;
        this.others = "";
      },
    },
    capacity: {
      handler: function() {
        console.log(this.capacity);
        console.log(this.alphanumeric(this.capacity), "capacity");
      },
    },
  },
  mounted() {
    if (this.step1Payload) {
      const {
        capacity,
        storage,
        name,
        minTemp,
        maxTemp,
        minHumidity,
        maxHumidity,
      } = this.step1Payload;
      this.group_name = name;
      this.capacity = capacity;
      this.minTemp = minTemp;
      this.maxTemp = maxTemp;
      this.minHumi = minHumidity;
      this.maxHumi = maxHumidity;
      if (
        storage !== "truck" &&
        storage !== "warehouse" &&
        storage !== "reefers"
      ) {
        this.storage = "others";
        this.others = storage;
      } else this.storage = storage;
      const storageType = this.storageTypes.find(
        (item) => item.value === this.storage
      );
      this.dropDownName = storageType.name;
    }
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.modal-dialog {
  max-width: 500px !important;
}
.storage-dropdown ul {
  list-style: none;
  padding: 0;
  z-index: 2;
}
.storage-dropdown li {
  border: 0.2px solid #8f8b8b;
  box-sizing: border-box;
  border-radius: 2px 2px 0px 0px;
  background-color: #e0e0e0;
}
.storage-dropdown li:hover {
  background: #bdbdbd;
}

.storage-dropdown li.active {
  background: #bdbdbd !important;
}
</style>

<i18n>
{
	"en": {
		"avg_humid": "Avg. Humidity",
		"avg_temp": "Avg. Temp",
		"create_grp": "Next",
		"group_monitor": "Group and monitor a selected cluster of devices in one view, instantly. Create a group to get started.",
		"group_name": "Group Name",
		"new_group": "New Group",
		"no_dev": "No device added",
		"no_group_yet": "You have no groups yet",
		"no_user": "No user added",
		"num_dev": "Number of Devices",
		"num_users": "Number of Users",
		"ur_groups": " Your groups will show here when the Admin assigns you to a Group.",
		"valid-measurement": "Must be a valid measurement e.g 10kg"
	},
	"fr": {
		"avg_humid": "Moyenne. Humidité",
		"avg_temp": "Moy. Temp",
		"create_grp": "Créer un groupe",
		"group_monitor": "Regroupez et surveillez un groupe sélectionné d'appareils dans une seule vue, instantanément. Créez un groupe pour commencer.",
		"group_name": "Nom de groupe",
		"new_group": "Nouveau groupe",
		"no_dev": "Aucun appareil ajouté",
		"no_group_yet": "Vous n'avez pas encore de groupes",
		"no_user": "Aucun utilisateur ajouté",
		"num_dev": "Nombre d'appareils",
		"num_users": "Nombre d'utilisateurs",
		"ur_groups": "Vos groupes s'afficheront ici lorsque l'administrateur vous affectera à un groupe.",
		"valid-measurement": "Doit être une mesure valide, par exemple 10 kg"
	},
	"sw": {
		"avg_humid": "Wastani. Unyevu",
		"avg_temp": "Wastani. Muda",
		"create_grp": "Ifuatayo",
		"group_monitor": "Panga na ufuatilie kundi lililochaguliwa la vifaa katika mwonekano mmoja, papo hapo. Unda kikundi ili uanze.",
		"group_name": "Jina la kikundi",
		"new_group": "Kikundi kipya",
		"no_dev": "Hakuna kifaa kilichoongezwa",
		"no_group_yet": "Bado huna vikundi",
		"no_user": "Hakuna mtumiaji aliyeongezwa",
		"num_dev": "Idadi ya Vifaa",
		"num_users": "Idadi ya Watumiaji",
		"ur_groups": " Vikundi vyako vitaonekana hapa Msimamizi atakapokukabidhi kwa Kikundi.",
		"valid-measurement": "Lazima kiwe kipimo halali k.m 10kg"
	}
}
</i18n>
